"use client"

import { Home } from "lucide-react"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html>
      <body>
        <div className="min-h-screen flex items-center justify-center bg-black text-white p-4">
          <div className="max-w-2xl text-center">
            <div className="mb-8">
              <h1 className="text-8xl font-bold mb-4 bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent">
                CRITICAL ERROR
              </h1>
              <h2 className="text-2xl font-bold mb-4">Application Crashed</h2>
              <p className="text-gray-400 mb-8">
                A critical error has occurred. Please refresh the page or return home.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={reset}
                className="px-8 py-4 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-all"
              >
                Try Again
              </button>
              <a
                href="/"
                className="px-8 py-4 bg-gray-800 text-white rounded-lg font-medium hover:bg-gray-700 transition-all flex items-center justify-center gap-2"
              >
                <Home className="w-5 h-5" />
                Go Home
              </a>
            </div>

            {process.env.NODE_ENV === "development" && (
              <div className="mt-8 p-4 bg-red-950/50 border border-red-900 rounded-lg text-left">
                <p className="text-xs font-mono text-red-400 break-all">
                  {error.message}
                </p>
              </div>
            )}
          </div>
        </div>
      </body>
    </html>
  )
}
